import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { useLocaleKeys } from '~/i18n';
export const useCustomPageText = (param)=>{
    let { sourceId, textId, enabled = true } = param;
    const { api } = useStoreActions();
    const { t } = useLocaleKeys();
    const isEnabled = enabled && sourceId != null && sourceId !== '' && textId != null && textId !== '';
    const { data, isLoading, isError } = useQueryState({
        queryKey: [
            QueryKeys.CustomPageText,
            sourceId,
            textId
        ],
        queryFn: async ()=>{
            const result = await api.customPage.getText(sourceId, textId);
            return result.value;
        },
        enabled: isEnabled,
        toasts: {
            errorMessage: t.customPages.templates.loadContentError()
        }
    });
    return {
        content: data,
        isLoading: isEnabled && isLoading,
        isError
    };
};
